import Component from "../../js/lib/component";
import Lazy from "../../js/lib/lazy";
import anime from "animejs";
import $ from "jquery";

const classList = {
  root: ".js-cards",
  list: ".js-cards-list",
  item: ".js-cards-item",
  body: ".js-cards-body"
};

export default class Cards extends Component {
  init() {
    this.Switch = this.childs("Switches")._one();

    this.mode = this.$.root.data("mode");
    this.setState({ isGrid: this.mode === "grid" });

    if (this.Switch) {
      this.state.currentType = this.Switch.state.currentType;
      this.state.$currentItems = this.filterItems(this.state.currentType);
    }
  }
  events() {
    if (this.Switch) {
      this.Switch.$.root.on("switches:change", (e, { type }) => {
        this.state.currentType = type;
        this.toggle(type);
      });
    }
  }
  toggle(type) {
    if (this.state.isGrid) {
      this.hide().then(() => {
        this.timer = setTimeout(() => {
          this.$.root.addClass("is-loading");
        }, 1000);

        this.load(type).then($cards => {
          clearTimeout(this.timer);

          this.state.$cards = $cards;

          this.$.item = $cards.find(classList.item);
          this.$.list = $cards.find(classList.list);

          this.renderItems(this.$.body, $cards);
          this.checkLazyImages($cards);
          this.show();

          this.$.root.removeClass("is-loading");
        });
      });
    } else {
      this.state.$currentItems = this.filterItems(this.state.currentType);
      this.hide().then(() => {
        this.renderItems(this.$.list, this.state.$currentItems);
        this.show();
      });
    }
  }
  checkLazyImages($cards) {
    if ($cards.find(Lazy.selector).length) {
      Lazy.init(false);
    }
  }
  load(type) {
    return new Promise(resolve => {
      let url = '/news' + (type ?  "/" + type : '');
      $.ajax(url)
        .done(({ cards }) => {
          resolve($(cards));
        })
        .fail(error => {
          console.error(error);
        });
    });
  }
  filterItems(type) {
    return type && type !== "all"
      ? this.$.item.filter((i, item) => $(item).data("type") === type)
      : this.$.item;
  }
  renderItems($container, $content) {
    $container.html($content);
  }
  hide() {
    return new Promise(resolve => {
      anime({
        targets: this.$.item.get(),
        opacity: 0,
        easing: "easeOutCubic",
        duration: 300,
        complete: () => {
          resolve();
        }
      });
    });
  }
  show() {
    const targets = this.state.isGrid
      ? this.$.item.get()
      : this.state.$currentItems.get();

    anime.set(targets, {
      opacity: 0,
      translateY: 30
    });

    if (this.Switch) {
      this.Switch.toggle();
    }

    return anime({
      targets,
      opacity: 1,
      translateY: 0,
      easing: "easeOutCubic",
      duration: 400,
      delay: anime.stagger(100)
    }).finished;
  }
}

Component.mount(Cards, {
  name: "Cards",
  classList,
  state: {
    currentType: null,
    $currentItems: null,
    $cards: null
  }
});
